// ComparisonTable.tsx
// Simple Free vs Platinum vs AI Platinum comparison list with checkmarks

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '../../../components/ui';
import { Theme } from '../../../utils/theme';

interface ComparisonRow {
  feature: string;
  free: boolean;
  platinum: boolean;  // Standard Platinum tier
  aiPlatinum: boolean; // AI Platinum tier
}

const FEATURES: ComparisonRow[] = [
  { feature: 'Basic AI onboarding', free: true, platinum: true, aiPlatinum: true },
  { feature: 'Limited book access', free: true, platinum: false, aiPlatinum: false },
  { feature: 'Unlimited books & insights', free: false, platinum: true, aiPlatinum: true },
  { feature: 'Personalized recommendations', free: false, platinum: true, aiPlatinum: true },
  { feature: 'AI Mentor Chat', free: false, platinum: false, aiPlatinum: true },
  { feature: 'Advanced AI recommendations', free: false, platinum: false, aiPlatinum: true },
  { feature: 'Personalized learning paths', free: false, platinum: false, aiPlatinum: true },
];

export const ComparisonTable: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.headerRow}>
        <View style={styles.featureColumn}>
          <Text variant="body2" style={styles.headerText}>Features</Text>
        </View>
        <View style={styles.checkColumn}>
          <Text variant="caption" style={styles.headerText}>Free</Text>
        </View>
        <View style={styles.checkColumn}>
          <Text variant="caption" style={styles.headerText}>Platinum</Text>
        </View>
        <View style={styles.checkColumn}>
          <Text variant="caption" style={[styles.headerText, styles.aiHeader]}>AI{'\n'}Platinum</Text>
        </View>
      </View>

      {/* Rows */}
      {FEATURES.map((row, index) => (
        <View key={index} style={styles.row}>
          <View style={styles.featureColumn}>
            <Text variant="body2" color="secondary" style={styles.featureText}>{row.feature}</Text>
          </View>
          <View style={styles.checkColumn}>
            <Text variant="body1" style={styles.checkmark}>
              {row.free ? '✓' : '—'}
            </Text>
          </View>
          <View style={styles.checkColumn}>
            <Text variant="body1" style={styles.checkmark}>
              {row.platinum ? '✓' : '—'}
            </Text>
          </View>
          <View style={styles.checkColumn}>
            <Text variant="body1" style={[styles.checkmark, styles.aiCheck]}>
              {row.aiPlatinum ? '✓' : '—'}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.colors.surface,
    borderRadius: Theme.borderRadius.lg,
    padding: Theme.spacing.md,
    borderWidth: 1,
    borderColor: Theme.colors.border,
  },
  headerRow: {
    flexDirection: 'row',
    paddingBottom: Theme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: Theme.colors.border,
    marginBottom: Theme.spacing.sm,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: Theme.spacing.xs,
  },
  featureColumn: {
    flex: 2.5,
    justifyContent: 'center',
    paddingRight: Theme.spacing.xs,
  },
  featureText: {
    fontSize: 13,
  },
  checkColumn: {
    flex: 0.8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerText: {
    fontWeight: '600',
    color: Theme.colors.textPrimary,
    fontSize: 11,
    textAlign: 'center',
  },
  aiHeader: {
    color: Theme.colors.primary,
  },
  checkmark: {
    fontSize: 16,
    color: Theme.colors.textSecondary,
  },
  aiCheck: {
    color: Theme.colors.primary,
    fontWeight: 'bold',
  },
});

